var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShipments(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: 24,
    height: 24,
    fill: "#2255a1",
    viewBox: "0 0 432 432",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23 36C10 36 0 46 0 59v246c0 14 11 25 24 25h17c4 23 24 41 48 41s44-18 48-41h92c6 0 11-3 15-6 5 3 10 6 16 6h9c4 23 24 41 48 41 27 0 49-22 49-49s-22-49-49-49c-24 0-44 18-48 41h-9c-1 0-4-1-5-3-2-2-3-4-3-6V126c0-3 5-8 8-8h65c6 0 15 6 22 14l1 2h-39c-13 0-25 10-25 24v33c0 6 4 12 8 17 4 4 10 7 17 7h81v90c0 4-5 9-8 9h-16v16h16c14 0 24-11 24-25V202c0-19-13-35-13-35l-33-45h-1c-7-9-18-21-34-21h-65c-3 0-5 1-8 2V60c0-13-10-24-23-24H23zm0 16h206c4 0 7 4 7 8v247c0 4-3 7-7 7h-92c-4-23-24-41-48-41s-44 18-48 41H24c-3 0-8-6-8-9V59c0-4 3-7 7-7zm286 98h51l20 26s8 13 9 23h-80c-2 0-4-1-5-3-2-2-3-4-3-5v-33c0-4 5-8 8-8zM89 289c18 0 32 15 32 33s-14 32-32 32-33-14-33-32 15-33 33-33zm228 0c18 0 32 15 32 33s-14 32-32 32-33-14-33-32 15-33 33-33z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShipments);
export default __webpack_public_path__ + "static/media/Shipments.614a654435ddb741390fb217939d44e8.svg";
export { ForwardRef as ReactComponent };